const STORAGE_KEY = 'gdprConsent';
const EXPIRY_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

const listeners = new Set();

function _readRaw() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function getConsent() {
  return _readRaw();
}

export function isConsentValid() {
  const parsed = _readRaw();
  if (!parsed || !parsed.timestamp) return false;
  const age = Date.now() - new Date(parsed.timestamp).getTime();
  return age < EXPIRY_MS;
}

export function saveConsent(accepted) {
  const payload = { accepted: !!accepted, timestamp: new Date().toISOString() };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    // ignore
  }
  listeners.forEach((cb) => {
    try { cb(payload); } catch (_) {}
  });
  return payload;
}

export function clearConsent() {
  try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
  listeners.forEach((cb) => {
    try { cb(null); } catch (_) {}
  });
}

export function onConsentChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function offConsentChange(cb) {
  listeners.delete(cb);
}

export { STORAGE_KEY, EXPIRY_MS };

const gdprService = {
  getConsent,
  isConsentValid,
  saveConsent,
  clearConsent,
  onConsentChange,
  offConsentChange,
  STORAGE_KEY,
  EXPIRY_MS,
};

export default gdprService;
